// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension="
// @generated from file rolodex.proto (package rolodex, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Ping
 *
 * @generated from message rolodex.PingRequest
 */
export class PingRequest extends Message<PingRequest> {
  constructor(data?: PartialMessage<PingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.PingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PingRequest {
    return new PingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PingRequest {
    return new PingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PingRequest {
    return new PingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PingRequest | PlainMessage<PingRequest> | undefined, b: PingRequest | PlainMessage<PingRequest> | undefined): boolean {
    return proto3.util.equals(PingRequest, a, b);
  }
}

/**
 * @generated from message rolodex.PingResponse
 */
export class PingResponse extends Message<PingResponse> {
  constructor(data?: PartialMessage<PingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.PingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PingResponse {
    return new PingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PingResponse {
    return new PingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PingResponse {
    return new PingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PingResponse | PlainMessage<PingResponse> | undefined, b: PingResponse | PlainMessage<PingResponse> | undefined): boolean {
    return proto3.util.equals(PingResponse, a, b);
  }
}

/**
 * GetSyncStatus
 *
 * @generated from message rolodex.GetSyncStatusRequest
 */
export class GetSyncStatusRequest extends Message<GetSyncStatusRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  constructor(data?: PartialMessage<GetSyncStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.GetSyncStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSyncStatusRequest {
    return new GetSyncStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSyncStatusRequest {
    return new GetSyncStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSyncStatusRequest {
    return new GetSyncStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSyncStatusRequest | PlainMessage<GetSyncStatusRequest> | undefined, b: GetSyncStatusRequest | PlainMessage<GetSyncStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetSyncStatusRequest, a, b);
  }
}

/**
 * @generated from message rolodex.SyncStatus
 */
export class SyncStatus extends Message<SyncStatus> {
  /**
   * @generated from field: google.protobuf.Timestamp synced_at = 1;
   */
  syncedAt?: Timestamp;

  /**
   * @generated from field: int32 matches_count = 2;
   */
  matchesCount = 0;

  constructor(data?: PartialMessage<SyncStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.SyncStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "synced_at", kind: "message", T: Timestamp },
    { no: 2, name: "matches_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SyncStatus {
    return new SyncStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SyncStatus {
    return new SyncStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SyncStatus {
    return new SyncStatus().fromJsonString(jsonString, options);
  }

  static equals(a: SyncStatus | PlainMessage<SyncStatus> | undefined, b: SyncStatus | PlainMessage<SyncStatus> | undefined): boolean {
    return proto3.util.equals(SyncStatus, a, b);
  }
}

/**
 * @generated from message rolodex.GetSyncStatusResponse
 */
export class GetSyncStatusResponse extends Message<GetSyncStatusResponse> {
  /**
   * @generated from field: rolodex.SyncStatus status = 1;
   */
  status?: SyncStatus;

  constructor(data?: PartialMessage<GetSyncStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.GetSyncStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "message", T: SyncStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSyncStatusResponse {
    return new GetSyncStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSyncStatusResponse {
    return new GetSyncStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSyncStatusResponse {
    return new GetSyncStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSyncStatusResponse | PlainMessage<GetSyncStatusResponse> | undefined, b: GetSyncStatusResponse | PlainMessage<GetSyncStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetSyncStatusResponse, a, b);
  }
}

/**
 * StartPhoneVerification
 *
 * @generated from message rolodex.StartPhoneVerificationRequest
 */
export class StartPhoneVerificationRequest extends Message<StartPhoneVerificationRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  /**
   * @generated from field: string phone = 2;
   */
  phone = "";

  constructor(data?: PartialMessage<StartPhoneVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.StartPhoneVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartPhoneVerificationRequest {
    return new StartPhoneVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartPhoneVerificationRequest {
    return new StartPhoneVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartPhoneVerificationRequest {
    return new StartPhoneVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartPhoneVerificationRequest | PlainMessage<StartPhoneVerificationRequest> | undefined, b: StartPhoneVerificationRequest | PlainMessage<StartPhoneVerificationRequest> | undefined): boolean {
    return proto3.util.equals(StartPhoneVerificationRequest, a, b);
  }
}

/**
 * @generated from message rolodex.StartPhoneVerificationResponse
 */
export class StartPhoneVerificationResponse extends Message<StartPhoneVerificationResponse> {
  constructor(data?: PartialMessage<StartPhoneVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.StartPhoneVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartPhoneVerificationResponse {
    return new StartPhoneVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartPhoneVerificationResponse {
    return new StartPhoneVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartPhoneVerificationResponse {
    return new StartPhoneVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartPhoneVerificationResponse | PlainMessage<StartPhoneVerificationResponse> | undefined, b: StartPhoneVerificationResponse | PlainMessage<StartPhoneVerificationResponse> | undefined): boolean {
    return proto3.util.equals(StartPhoneVerificationResponse, a, b);
  }
}

/**
 * VerifyPhone
 *
 * @generated from message rolodex.VerifyPhoneRequest
 */
export class VerifyPhoneRequest extends Message<VerifyPhoneRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  /**
   * @generated from field: string phone = 2;
   */
  phone = "";

  /**
   * @generated from field: string verification_code = 3;
   */
  verificationCode = "";

  constructor(data?: PartialMessage<VerifyPhoneRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.VerifyPhoneRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyPhoneRequest {
    return new VerifyPhoneRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyPhoneRequest {
    return new VerifyPhoneRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyPhoneRequest {
    return new VerifyPhoneRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyPhoneRequest | PlainMessage<VerifyPhoneRequest> | undefined, b: VerifyPhoneRequest | PlainMessage<VerifyPhoneRequest> | undefined): boolean {
    return proto3.util.equals(VerifyPhoneRequest, a, b);
  }
}

/**
 * @generated from message rolodex.VerifyPhoneResponse
 */
export class VerifyPhoneResponse extends Message<VerifyPhoneResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<VerifyPhoneResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.VerifyPhoneResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyPhoneResponse {
    return new VerifyPhoneResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyPhoneResponse {
    return new VerifyPhoneResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyPhoneResponse {
    return new VerifyPhoneResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyPhoneResponse | PlainMessage<VerifyPhoneResponse> | undefined, b: VerifyPhoneResponse | PlainMessage<VerifyPhoneResponse> | undefined): boolean {
    return proto3.util.equals(VerifyPhoneResponse, a, b);
  }
}

/**
 * ImportContacts
 *
 * @generated from message rolodex.ImportContactsRequest
 */
export class ImportContactsRequest extends Message<ImportContactsRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  /**
   * @generated from field: repeated string contacts = 3;
   */
  contacts: string[] = [];

  constructor(data?: PartialMessage<ImportContactsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.ImportContactsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "contacts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportContactsRequest {
    return new ImportContactsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportContactsRequest {
    return new ImportContactsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportContactsRequest {
    return new ImportContactsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportContactsRequest | PlainMessage<ImportContactsRequest> | undefined, b: ImportContactsRequest | PlainMessage<ImportContactsRequest> | undefined): boolean {
    return proto3.util.equals(ImportContactsRequest, a, b);
  }
}

/**
 * @generated from message rolodex.ImportContactsMatch
 */
export class ImportContactsMatch extends Message<ImportContactsMatch> {
  /**
   * To which index of the input contacts this contact corresponds.
   *
   * @generated from field: int32 input_index = 1;
   */
  inputIndex = 0;

  /**
   * @generated from field: string subject = 2;
   */
  subject = "";

  constructor(data?: PartialMessage<ImportContactsMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.ImportContactsMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "input_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportContactsMatch {
    return new ImportContactsMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportContactsMatch {
    return new ImportContactsMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportContactsMatch {
    return new ImportContactsMatch().fromJsonString(jsonString, options);
  }

  static equals(a: ImportContactsMatch | PlainMessage<ImportContactsMatch> | undefined, b: ImportContactsMatch | PlainMessage<ImportContactsMatch> | undefined): boolean {
    return proto3.util.equals(ImportContactsMatch, a, b);
  }
}

/**
 * @generated from message rolodex.ImportContactsResponse
 */
export class ImportContactsResponse extends Message<ImportContactsResponse> {
  /**
   * @generated from field: repeated rolodex.ImportContactsMatch matches = 1;
   */
  matches: ImportContactsMatch[] = [];

  constructor(data?: PartialMessage<ImportContactsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.ImportContactsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "matches", kind: "message", T: ImportContactsMatch, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportContactsResponse {
    return new ImportContactsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportContactsResponse {
    return new ImportContactsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportContactsResponse {
    return new ImportContactsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportContactsResponse | PlainMessage<ImportContactsResponse> | undefined, b: ImportContactsResponse | PlainMessage<ImportContactsResponse> | undefined): boolean {
    return proto3.util.equals(ImportContactsResponse, a, b);
  }
}

/**
 * GetMatches
 *
 * @generated from message rolodex.GetMatchesRequest
 */
export class GetMatchesRequest extends Message<GetMatchesRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetMatchesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.GetMatchesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMatchesRequest {
    return new GetMatchesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMatchesRequest {
    return new GetMatchesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMatchesRequest {
    return new GetMatchesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMatchesRequest | PlainMessage<GetMatchesRequest> | undefined, b: GetMatchesRequest | PlainMessage<GetMatchesRequest> | undefined): boolean {
    return proto3.util.equals(GetMatchesRequest, a, b);
  }
}

/**
 * @generated from message rolodex.GetMatchesResponse
 */
export class GetMatchesResponse extends Message<GetMatchesResponse> {
  /**
   * @generated from field: repeated string subjects = 1;
   */
  subjects: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetMatchesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.GetMatchesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subjects", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMatchesResponse {
    return new GetMatchesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMatchesResponse {
    return new GetMatchesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMatchesResponse {
    return new GetMatchesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMatchesResponse | PlainMessage<GetMatchesResponse> | undefined, b: GetMatchesResponse | PlainMessage<GetMatchesResponse> | undefined): boolean {
    return proto3.util.equals(GetMatchesResponse, a, b);
  }
}

/**
 * DismissMatch
 *
 * @generated from message rolodex.DismissMatchRequest
 */
export class DismissMatchRequest extends Message<DismissMatchRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  /**
   * @generated from field: string subject = 2;
   */
  subject = "";

  constructor(data?: PartialMessage<DismissMatchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.DismissMatchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DismissMatchRequest {
    return new DismissMatchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DismissMatchRequest {
    return new DismissMatchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DismissMatchRequest {
    return new DismissMatchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DismissMatchRequest | PlainMessage<DismissMatchRequest> | undefined, b: DismissMatchRequest | PlainMessage<DismissMatchRequest> | undefined): boolean {
    return proto3.util.equals(DismissMatchRequest, a, b);
  }
}

/**
 * @generated from message rolodex.DismissMatchResponse
 */
export class DismissMatchResponse extends Message<DismissMatchResponse> {
  /**
   * @generated from field: int32 matches_count = 1;
   */
  matchesCount = 0;

  constructor(data?: PartialMessage<DismissMatchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.DismissMatchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "matches_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DismissMatchResponse {
    return new DismissMatchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DismissMatchResponse {
    return new DismissMatchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DismissMatchResponse {
    return new DismissMatchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DismissMatchResponse | PlainMessage<DismissMatchResponse> | undefined, b: DismissMatchResponse | PlainMessage<DismissMatchResponse> | undefined): boolean {
    return proto3.util.equals(DismissMatchResponse, a, b);
  }
}

/**
 * RemoveData
 *
 * @generated from message rolodex.RemoveDataRequest
 */
export class RemoveDataRequest extends Message<RemoveDataRequest> {
  /**
   * @generated from field: string actor = 1;
   */
  actor = "";

  constructor(data?: PartialMessage<RemoveDataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.RemoveDataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDataRequest {
    return new RemoveDataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDataRequest {
    return new RemoveDataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDataRequest {
    return new RemoveDataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDataRequest | PlainMessage<RemoveDataRequest> | undefined, b: RemoveDataRequest | PlainMessage<RemoveDataRequest> | undefined): boolean {
    return proto3.util.equals(RemoveDataRequest, a, b);
  }
}

/**
 * @generated from message rolodex.RemoveDataResponse
 */
export class RemoveDataResponse extends Message<RemoveDataResponse> {
  /**
   * @generated from field: int32 contacts_count = 1;
   */
  contactsCount = 0;

  /**
   * @generated from field: int32 matches_count = 2;
   */
  matchesCount = 0;

  constructor(data?: PartialMessage<RemoveDataResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "rolodex.RemoveDataResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "matches_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDataResponse {
    return new RemoveDataResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDataResponse {
    return new RemoveDataResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDataResponse {
    return new RemoveDataResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDataResponse | PlainMessage<RemoveDataResponse> | undefined, b: RemoveDataResponse | PlainMessage<RemoveDataResponse> | undefined): boolean {
    return proto3.util.equals(RemoveDataResponse, a, b);
  }
}

